import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { breakpoints } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';

const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    @media (max-width: ${breakpoints.mobile}) {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
`;

const BottomSheet = ({ children, open, handleClose }) => {
  const isMobile = useIsMobile();
  return (
    <StyledDrawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={handleClose}
    >
      {children}
    </StyledDrawer>
  );
};

export default BottomSheet;

BottomSheet.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func
};

BottomSheet.defaultProps = {
  children: null,
  handleClose: () => {}
};
